import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_VEHICLES_DOCUMENTS_DATA } from "./actionTypes";
import {
  fetchVehiclesDocumentsSuccess,
  fetchVehiclesDocumentsFailure,
} from "./actions";

function* fetchVehiclesDocumentsDataSaga(data) {
  try {
    let url = process.env.REACT_APP_WEB_APP_URL + `/api/web/vehicles-documents`;
    if (data.driverId) {
      url += `?driverId=${data.driverId}`;
    }
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, url,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchVehiclesDocumentsSuccess(response.data));
  } catch (error) {
    yield put(fetchVehiclesDocumentsFailure(error.message));
  }
}

export default function* vehiclesDocumentsSaga() {
  yield takeEvery(FETCH_VEHICLES_DOCUMENTS_DATA, fetchVehiclesDocumentsDataSaga);
}
